import { Field } from "@typings/Cue";
import { Name, Type } from "@typings/enums";
import { cn, getFieldValue } from "@util/helpers";
import { stringify } from "querystringify";

export type YouTubeVideoProps = {
  fields: Field[];
  className?: string;
  iframeClassName?: string;
};
export default function YouTubeVideo({
  className,
  fields,
  iframeClassName,
}: YouTubeVideoProps): React.ReactElement {
  const title = getFieldValue(fields, Name.Title)?.toString();
  const id = getFieldValue(fields, Name.YoutubeId);
  const autoPlay = getFieldValue(fields, Name.AutoPlay);
  const showCaption = getFieldValue(fields, Name.ClosedCaption);
  const allowFullScreen = getFieldValue(fields, Name.AllowFullScreen);

  const defaultParams = {
    enablejsapi: 1,
  };

  const params = {
    ...(autoPlay && { autoplay: 1 }),
    ...(showCaption && { cc_load_policy: 1 }),
    ...(!allowFullScreen && { fs: 0 }),
    ...defaultParams,
  };

  return (
    <>
      {id ? (
        <div
          className={className}
          data-story-element={Type.YoutubeVideo}
          data-testid="youtube-video-component"
        >
          <iframe
            className={cn("aspect-video w-full", iframeClassName)}
            src={
              Object.keys(params).length > 0
                ? `https://www.youtube.com/embed/${id}?${stringify(params)}`
                : `https://www.youtube.com/embed/${id}?${stringify(defaultParams)}`
            }
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            title={title}
          ></iframe>
        </div>
      ) : null}
    </>
  );
}
